<div [class.maximized]="isMaximized" class="iframe-container">
    <iframe
        [src]="src"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        frameborder="0"
    ></iframe>

    <div cdkDrag>
        <button
            mat-icon-button
            *ngIf="!hideButtonWhenMinimized || isMaximized"
            appPureClick
            (appPureClick)="toggleMaximize()"
            class="maximize-button"
        >
            <mat-icon>
                {{ isMaximized ? "fullscreen_exit" : "fullscreen" }}
            </mat-icon>
        </button>
    </div>
</div>
